import { topLevelDomainMap } from '@/i18n/domainConfig';
import { QA_VMS, applyQaVMHack, getQaRuntimeVM } from '@/utility/applyQAVMHack';
import { Locale } from '@/utility/locale';

const rewriteTldForQa = (parts: string[]) => {
  if (parts.length <= 2) return;

  const originalTld = parts.slice(2).join('.');
  const transformedTld = applyQaVMHack(originalTld);

  parts.splice(2, parts.length - 2, ...transformedTld.split('.'));
};

/**
 * Build a URL that swaps the subdomain while keeping the current hostname/TLD.
 * In local QA mode (local.spreadshirt.* + vm286 runtime), the hostname flips to vm286
 * and the TLD gets the usual QA "v" hack.
 */
export const buildCrossDomainUrl = (targetSubdomain: string, path: string = ''): string => {
  if (typeof window === 'undefined') return '';

  const hostnameParts = window.location.hostname.split('.');
  const [currentSubdomain, currentHostname] = hostnameParts;

  const runtimeVM = getQaRuntimeVM();
  const shouldUseLocalQaDomain =
    currentSubdomain === 'local' &&
    !(currentHostname && QA_VMS.includes(currentHostname)) &&
    runtimeVM !== undefined;

  const targetParts = [...hostnameParts];
  targetParts[0] = targetSubdomain;

  if (shouldUseLocalQaDomain) {
    targetParts[1] = runtimeVM;
    rewriteTldForQa(targetParts);
  }

  return `https://${targetParts.join('.')}${path}`;
};

/**
 * Create-omat is served per country, so the CREATE_OMAT_URL base keeps its subdomain and
 * hostname but gets the TLD of the current locale (e.g. create-omat.spreadshirt.net ->
 * create-omat.spreadshirt.de).
 */
export const getCreateOmatUrl = (baseUrl: string, locale: Locale): string => {
  const tld = topLevelDomainMap[locale];
  if (!tld) return baseUrl;

  const url = new URL(baseUrl);
  const hostnameParts = url.hostname.split('.');
  if (hostnameParts.length <= 2) return baseUrl;

  url.hostname = [...hostnameParts.slice(0, 2), ...applyQaVMHack(tld).split('.')].join('.');

  return url.origin;
};
